import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getUsers,
    selectUser,
    getUsersError,
    clearUserDeviceIdsList,
    changePassword,
    getAllUsersForSuperAdmin, getUserModules
} from '../store/actions/usersActions';
import { getCompanies } from "../store/actions/companiesActions";
import { toggleModal } from '../store/actions/toggleModalActions';
import './ManageUsers.scss';

import Spinner from './_common/Spinner';
import { ReactComponent as AddUserIcon } from '../assets/icons/add_user.svg';
import List from "./_common/List";
import UserModal from "./UserModal";
import ErrorModal from "./_common/ErrorModal";
import ConfirmationModal from "./_common/ConfirmationModal";
import ChangePasswordModal from "./ChangePasswordModal";
import DetailsModal from "./_common/DetailsModal";
import ManageUsersDetails from "./ManageUsersDetails";
import MobileAddEditModal from "./_common/MobileModals/MobileAddEditModal";
import {getLoggedUserId, isSuperAdmin} from "../helpers/helpers";
import {getSensorReports, setSensorReportsFilters} from "../store/actions/sensorReportsActions";

const selector = state => {
    const { language, users, modalState, companies } = state;
    return {
        t: language.translator,
        pending: users.pending,
        pendingCompanies: companies.pending,
        users: users.users,
        page: users.page,
        pageCount: users.pageCount,
        userCount: users.userCount,
        selected: users.selected,
        error: users.error,
        modalState: modalState,
        companies: companies.companies
    }
};

const ManageUsers = props => {
    const { t, pending, pendingCompanies, users, page, pageCount, userCount, selected, error, modalState, companies } = useSelector(selector);
    const {userPicker, selectUserPicker, toggleUserPicker, superAdmin} = props;
    const dispatch = useDispatch();
    const [searchInput, setSearchInput] = useState('');
    const [search, setSearch] = useState('');
    const [onlyInvoiceRequiredFilter, setOnlyInvoiceRequiredFilter] = useState(false);
    const [onlyNotActiveSensorsFilter, setOnlyNotActiveSensorsFilter] = useState(false);
    const [showSortingOptions, setShowSortingOptions] = useState(false);
    const [selectedSortingOption, setSelectedSortingOption] = useState(null);

    useEffect(() => {
        dispatch(getCompanies(1, 9999));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(superAdmin) {
            dispatch(getAllUsersForSuperAdmin(1, search, onlyNotActiveSensorsFilter, selectedSortingOption?.value))
        } else {
            dispatch(getUsers(1, search, onlyInvoiceRequiredFilter));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search, onlyInvoiceRequiredFilter, onlyNotActiveSensorsFilter, selectedSortingOption]);

    const handleClearDeviceIdsClick = () => {
        dispatch(toggleModal(true, 'Clear device Ids'));
    };

    const closeModal = () => {
        dispatch(toggleModal(false, ''))
    };

    const clearDeviceIds = () => {
        dispatch(clearUserDeviceIdsList(selected.user.id));
    }

    const handleResetPasswordClick = () => {
        dispatch(toggleModal(true, 'Reset password'));
    };

    const resetPassword = newPassword => {
        dispatch(changePassword(selected.user, newPassword));
    }

    const selectUserPick = (item) => {
        selectUserPicker(item.id, item.email)
    }

    const sortingOptions = [
        {label: t.gettext('First Name'), value: 'FIRST_NAME'},
        {label: t.gettext('Creation Date'), value: 'CREATION_DATE'},
        {label: t.gettext('Last Login'), value: 'LAST_LOGIN'},
    ]

    const getUsersPage = (pageNumber, _itemsPerPage, _filter, _userId, searchValue) => {
        if (superAdmin) {
            return getAllUsersForSuperAdmin(
                pageNumber,
                searchValue,
                onlyNotActiveSensorsFilter,
                selectedSortingOption?.value
            );
        }

        return getUsers(pageNumber, searchValue, onlyInvoiceRequiredFilter);
    };

    const getListConfig = (isMobile, onlyNotActiveSensorsFilter, isSuperAdmin) => {
        if (isMobile) {
            // MOBILE version
            const columnsNames = onlyNotActiveSensorsFilter
                ? ['Email', 'Company', 'Inactive Sensors']
                : ['Last Name', 'Email', 'Company'];

            const columns = onlyNotActiveSensorsFilter
                ? ['email', 'companyId', 'inactiveSensorNumber']
                : ['lastName', 'email', 'companyId'];

            const columnsWidths = onlyNotActiveSensorsFilter
                ? ['40%', '30%', '20%']
                : ['30%', '40%', '30%'];

            const referenceColumn = onlyNotActiveSensorsFilter ? 2 : 3;

            return { columnsNames, columns, columnsWidths, referenceColumn };
        } else {
            // WEB version
            let columnsNames = onlyNotActiveSensorsFilter
                ? ['First Name', 'Last Name', 'Email', 'Company', 'Inactive Sensors']
                : ['First Name', 'Last Name', 'Email', 'Company'];

            let columns = onlyNotActiveSensorsFilter
                ? ['firstName', 'lastName', 'email', 'companyId', 'inactiveSensorNumber']
                : ['firstName', 'lastName', 'email', 'companyId'];

            const referenceColumn = 5;

            if (isSuperAdmin) {
                columnsNames.splice(2, 0, 'Created At');
                columns.splice(2, 0, 'createdAt');
            }

            return { columnsNames, columns, referenceColumn };
        }
    };

    const { columnsNames, columns, columnsWidths, referenceColumn } =
        getListConfig(modalState.isTabletOrMobile, onlyNotActiveSensorsFilter, superAdmin);



    if(pending || pendingCompanies) {
        return (
            <div className='page'>
                <Spinner size={300}/>
            </div>
        );
    }



    if(modalState.isTabletOrMobile) {
        return (
            <>
                <div className="ManageUsersMobile">
                    <div className="mManageUsersTitle">
                        <span>{t.gettext('User Management')}</span>
                    </div>
                    <div className="mManageUsersContainer">
                        <div className="mAddNewUserTitle">
                            <span>{t.gettext('Add new user')}</span>
                        </div>
                        <div className="mManageUsersIcon">
                            <div className='mManageUsersBtn'
                                 onClick={() => dispatch(toggleModal(true,  'Add user'))}>
                                <span className='material-icons'>add</span>
                            </div>
                        </div>
                    </div>
                    <div className="mManageUsersFilters">
                        <div className='mSearchBar'>
                            <div className='searchInputWrapper'>
                                <input
                                    type='text'
                                    className='mSearchInput'
                                    value={searchInput}
                                    onChange={e => setSearchInput(e.target.value)}
                                />
                                {search
                                    ? <span
                                        className='material-icons searchCancelButton'
                                        onClick={() => {
                                            setSearch('');
                                            setSearchInput('');
                                        }}
                                    >
                                        cancel
                                    </span>
                                    : null
                                }
                            </div>
                            <button
                                className='searchButton'
                                onClick={e => {
                                    e.preventDefault();
                                    setSearch(searchInput)
                                }}
                                disabled={!searchInput}
                            >
                                {t.gettext('SEARCH')}
                            </button>
                        </div>
                        {!superAdmin && (
                            <div className="mCheckboxContainer">
                                <input
                                    type='checkbox'
                                    className='filterCheckbox'
                                    id={'invoiceCheckbox'}
                                    checked={onlyInvoiceRequiredFilter}
                                    onChange={() => setOnlyInvoiceRequiredFilter(!onlyInvoiceRequiredFilter)}
                                />
                                <label htmlFor={'invoiceCheckbox'} className='filterCheckboxLabel'>
                                    {t.gettext('Only invoice required')}
                                </label>
                            </div>
                        )}
                        {superAdmin && (
                            <div className="mCheckboxContainer">
                                <input
                                    type='checkbox'
                                    className='filterCheckbox'
                                    id={'notActiveSensor'}
                                    checked={onlyNotActiveSensorsFilter}
                                    onChange={() => setOnlyNotActiveSensorsFilter(!onlyNotActiveSensorsFilter)}
                                />
                                <label htmlFor={'notActiveSensor'} className='filterCheckboxLabel'>
                                    {t.gettext('Only users with inactive sensors')}
                                </label>
                            </div>
                        )}
                        {superAdmin && (
                            <div
                                className='filterTypeFormSelect'
                                onClick={() => setShowSortingOptions(!showSortingOptions)}
                            >
                                <div className='filterTypeFormSelectText'>
                                    {/*{filters.numberOfDaysInPast ? numberOfDays.find(x => x.value.toString() === filters.numberOfDaysInPast.toString())?.label : t.gettext('Number of days')}*/}
                                    {selectedSortingOption ? t.gettext('Sorted By: ') +  selectedSortingOption.label : t.gettext('Sort By')}
                                </div>
                                <i className="material-icons dropDownIcon">
                                    {showSortingOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                                </i>
                                {showSortingOptions &&
                                    <div className='filterTypeFormSelectOptions'>
                                        {sortingOptions.map((item, index) => (
                                            <div
                                                className='filterTypeFormSelectOption'
                                                key={index}
                                                onClick={() => {
                                                    setSelectedSortingOption(item)
                                                }}
                                            >
                                                {item.label}
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        )}
                    </div>
                    <div className="mManageUsersList">
                        <List
                            items={users}
                            page={page}
                            pageCount={pageCount}
                            itemsCount={userCount}
                            // columnsNames={['Last Name', 'Email', 'Company']}
                            // columns={['lastName', 'email', 'companyId']}
                            columnsNames={onlyNotActiveSensorsFilter ?  ['Email', 'Company', 'Inactive Sensors'] : ['Last Name', 'Email', 'Company']}
                            columns={onlyNotActiveSensorsFilter ?  [ 'email', 'companyId', 'inactiveSensorNumber'] : ['lastName', 'email', 'companyId']}
                            columnsWidths={onlyNotActiveSensorsFilter ? ['40%', '30%', '20%', ] : ['30%', '40%', '30%']}
                            filter=''
                            // avatarColumn={1}
                            avatarUrl='iconUrl'
                            getItemsMethod={getUsersPage}
                            picker={userPicker}
                            selectItemMethod={userPicker ? selectUserPick : selectUser}
                            onSelectModalName={userPicker ? toggleUserPicker : 'User details'}
                            search={search}
                            referenceColumn={onlyNotActiveSensorsFilter ? 2 : 3}
                            referenceField='name'
                            referenceData={companies}
                        />
                    </div>
                </div>
                <MobileAddEditModal
                    isPanelOpen={modalState.flag && (modalState.modal === 'Add user' || modalState.modal === 'User details')}
                    edit={modalState.modal === 'User details'}
                    title={modalState.flag && t.gettext(modalState.modal)}
                    closeMethod={() => dispatch(toggleModal(false, ''))}
                >
                    {(modalState.flag && modalState.modal === 'Add user') &&
                        <UserModal
                            responsive
                            superAdmin={superAdmin}
                        />
                    }
                    {(modalState.flag && modalState.modal === 'User details') &&
                        <>
                            <UserModal
                                superAdmin={superAdmin}
                                edit
                                user={selected.user}
                                responsive
                                details
                                handleClearDeviceIdsClick={handleClearDeviceIdsClick}
                                handleResetPasswordClick={handleResetPasswordClick}
                            />
                        </>
                    }
                    {error &&
                        <ErrorModal
                            error={error}
                            closeMethod={() => dispatch(getUsersError(''))}
                        />
                    }
                </MobileAddEditModal>
                {(modalState.flag && modalState.modal === 'Clear device Ids') &&
                    <ConfirmationModal
                        text={t.gettext('List of device ids will be cleared')}
                        closeMethod={closeModal}
                        confirmMethod={clearDeviceIds}
                        confirmButtonText={t.gettext('Clear device Ids list')}
                    />
                }

                {(modalState.flag && modalState.modal === 'Reset password') &&
                    <ChangePasswordModal
                        closeMethod={closeModal}
                        confirmMethod={resetPassword}
                        confirmButtonText={t.gettext('Change password')}
                        user={selected.user}
                    />
                }
            </>
        )
    }

    return (
        <div className='userManagement' style={userPicker ? {minWidth: '80vw'} : null}>
            {!userPicker &&
                <div className="userManagementHeader">
                <span className='userManagementHeaderTitle'>
                    {t.gettext('User')}
                    &nbsp;
                </span>
                    <span className='userManagementHeaderTitle userManagementHeaderTitle--bold'>
                    {t.gettext('Management')}
                        {superAdmin && (
                            <>
                                &nbsp;
                                {t.gettext('Admin')}
                            </>
                        )}
                </span>

                    <div className='addUserButton' onClick={() => dispatch(toggleModal(true, 'Add user'))}>
                        <AddUserIcon className='addUserIcon' />
                    </div>
                </div>
            }


            <div className='searchBar'>
                <div className='searchInputWrapper'>
                    <input
                        type='text'
                        className='searchInput'
                        value={searchInput}
                        onChange={e => setSearchInput(e.target.value)}
                    />
                    {search
                        ? <span
                            className='material-icons searchCancelButton'
                            onClick={() => {
                                setSearch('');
                                setSearchInput('');
                            }}
                        >
                        cancel
                    </span>
                        : null
                    }
                </div>
                <button
                    className='searchButton'
                    onClick={e => {
                        e.preventDefault();
                        setSearch(searchInput)
                    }}
                    disabled={!searchInput}
                >
                    {t.gettext('SEARCH')}
                </button>
                {!superAdmin && (
                    <>
                        <input
                            type='checkbox'
                            className='filterCheckbox'
                            checked={onlyInvoiceRequiredFilter}
                            onChange={() => setOnlyInvoiceRequiredFilter(!onlyInvoiceRequiredFilter)}
                        />
                        <label className='filterCheckboxLabel'>
                            {t.gettext('Only invoice required')}
                        </label>
                    </>
                )}
                {superAdmin && (
                    <>
                        <input
                            type='checkbox'
                            className='filterCheckbox'
                            checked={onlyNotActiveSensorsFilter}
                            onChange={() => setOnlyNotActiveSensorsFilter(!onlyNotActiveSensorsFilter)}
                        />
                        <label className='filterCheckboxLabel'>
                            {t.gettext('Only users with inactive sensors')}
                        </label>
                    </>
                )}
                {superAdmin && (
                    <div
                        className='filterTypeFormSelect'
                        onClick={() => setShowSortingOptions(!showSortingOptions)}
                    >
                        <div className='filterTypeFormSelectText'>
                            {/*{filters.numberOfDaysInPast ? numberOfDays.find(x => x.value.toString() === filters.numberOfDaysInPast.toString())?.label : t.gettext('Number of days')}*/}
                            {selectedSortingOption ? selectedSortingOption.label : t.gettext('Sort By')}
                        </div>
                        <i className="material-icons dropDownIcon">
                            {showSortingOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                        </i>
                        {showSortingOptions &&
                            <div className='filterTypeFormSelectOptions'>
                                {sortingOptions.map((item, index) => (
                                    <div
                                        className='filterTypeFormSelectOption'
                                        key={index}
                                        onClick={() => {
                                                setSelectedSortingOption(item)
                                        }}
                                    >
                                        {item.label}
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                )}
            </div>

            {/*<List*/}
            {/*    items={users}*/}
            {/*    page={page}*/}
            {/*    pageCount={pageCount}*/}
            {/*    itemsCount={userCount}*/}
            {/*    columnsNames={onlyNotActiveSensorsFilter ?  ['First Name', 'Last Name', 'Email', 'Company', 'Inactive Sensors'] : ['First Name', 'Last Name', 'Email', 'Company']}*/}
            {/*    columns={onlyNotActiveSensorsFilter ?  ['firstName', 'lastName', 'email', 'companyId', 'inactiveSensorNumber'] : ['firstName', 'lastName', 'email', 'companyId']}*/}
            {/*    filter=''*/}
            {/*    avatarColumn={1}*/}
            {/*    avatarUrl='iconUrl'*/}
            {/*    getItemsMethod={superAdmin ? getAllUsersForSuperAdmin : getUsers}*/}
            {/*    picker={userPicker}*/}
            {/*    selectItemMethod={userPicker ? selectUserPick : selectUser}*/}
            {/*    onSelectModalName={userPicker ? toggleUserPicker : 'User details'}*/}
            {/*    search={search}*/}
            {/*    referenceColumn={4}*/}
            {/*    referenceField='name'*/}
            {/*    referenceData={companies}*/}
            {/*/>*/}
            <List
                items={users}
                page={page}
                pageCount={pageCount}
                itemsCount={userCount}
                columnsNames={columnsNames}
                columns={columns}
                {...(columnsWidths && { columnsWidths })}
                filter=''
                avatarColumn={1}
                dateColumn={3}
                avatarUrl='iconUrl'
                getItemsMethod={getUsersPage}
                picker={userPicker}
                selectItemMethod={userPicker ? selectUserPick : selectUser}
                onSelectModalName={userPicker ? toggleUserPicker : 'User details'}
                search={search}
                referenceColumn={referenceColumn}
                referenceField='name'
                referenceData={companies}
            />

            {(modalState.flag && modalState.modal === 'Add user') &&
                <UserModal
                    superAdmin={superAdmin}
                />
            }

            {(modalState.flag && modalState.modal === 'Edit user') &&
                <UserModal
                    edit
                    user={selected.user}
                    superAdmin={superAdmin}
                    handleClearDeviceIdsClick={handleClearDeviceIdsClick}
                    handleResetPasswordClick={handleResetPasswordClick}
                />
            }

            {error &&
                <ErrorModal
                    error={error}
                    closeMethod={() => dispatch(getUsersError(''))}
                />
            }

            {(modalState.flag && modalState.modal === 'Clear device Ids') &&
                <ConfirmationModal
                  text={t.gettext('List of device ids will be cleared')}
                  closeMethod={closeModal}
                  confirmMethod={clearDeviceIds}
                  confirmButtonText={t.gettext('Clear device Ids list')}
                />
            }

            {(modalState.flag && modalState.modal === 'Reset password') &&
                <ChangePasswordModal
                  closeMethod={closeModal}
                  confirmMethod={resetPassword}
                  confirmButtonText={t.gettext('Change password')}
                  user={selected.user}
                />
            }
            {(modalState.flag && modalState.modal === 'User details') &&
                <DetailsModal
                    closeMethod={closeModal}
                >
                    <ManageUsersDetails
                        closeMethod={closeModal}
                        edit
                        superAdmin={superAdmin}
                        user={selected.user}
                        handleClearDeviceIdsClick={handleClearDeviceIdsClick}
                        handleResetPasswordClick={handleResetPasswordClick}
                    />
                </DetailsModal>
            }
        </div>
    );
};

export default ManageUsers;
